import React, { ReactElement } from 'react'

import './Preloader.scss'

export default function Preloader(): ReactElement {
  return <div className="preloader">Loading…</div>
}
